import { ArrowLeftOnRectangleIcon, ChevronLeftIcon, EllipsisVerticalIcon } from '@heroicons/react/24/outline'
import { useRouter } from 'next/router'
import React, { MouseEventHandler, useEffect, useRef, useState } from 'react'
import TermsAndPrivacy from './TermsAndPrivacy'
import { PRIVACY_POLICY, TERMS_OF_SERVICE } from '@/utils/constants'
import amplitude from '@/amplitude'

function Nav({ pathname, goBack }: { pathname?: string; goBack?: () => void }) {
  const [showMenu, setShowMenu] = useState(false)
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false)
  const [showTermsOfService, setShowTermsOfService] = useState(false)
  const menuRef = useRef<HTMLDivElement | null>(null)

  const toggleMenu = (event: any) => {
    event.stopPropagation()
    setShowMenu(!showMenu)
  }

  const router = useRouter()
  const routePath = router.pathname
  const { venue_uuid, ordering } = router.query

  const handleLogout = () => {
    amplitude.setUserId(undefined)
    const venueUUID = router.query.venue_uuid

    localStorage.clear()
    router.push(`/?venue_uuid=${venue_uuid}${ordering === 'false' ? '&ordering=false' : ''}`).then(() => {
      window.location.reload()
    })
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowMenu(false)
      }
    }

    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])
  return (
    <nav className="w-full text-center relative p-2">
      {goBack && (
        <div onClick={goBack}>
          <ChevronLeftIcon className="absolute w-6" />
        </div>
      )}
      <span className="uppercase text-md tracking-tight">{pathname}</span>
      {!routePath.includes('tab') && !routePath.includes('status-details') && (
        <button className="absolute right-2" onClick={toggleMenu}>
          <EllipsisVerticalIcon className="w-7" />
        </button>
      )}

      {showMenu && (
        <div className="relative" ref={menuRef}>
          <div className="absolute end-0 z-10 mt-2 w-56 rounded-md border border-gray-100 bg-white shadow-lg" role="menu">
            <div className="p-2">
              <button
                className="flex w-full flexa rounded-lg px-4 py-2 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700 cursor-auto"
                role="menuitem"
                onClick={() => setShowPrivacyPolicy(true)}
              >
                Privacy Policy
              </button>
              <button
                className="flex w-full flexa rounded-lg px-4 py-2 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700 cursor-auto"
                role="menuitem"
                onClick={() => setShowTermsOfService(true)}
              >
                Terms Of Service
              </button>
              <button
                className="w-full flexa rounded-lg px-4 py-2 text-sm text-primary-red hover:bg-gray-50 hover:text-red-700 flex items-center cursor-auto"
                role="menuitem"
                onClick={handleLogout}
              >
                <ArrowLeftOnRectangleIcon className="w-6" /> Log out
              </button>
            </div>
          </div>
        </div>
      )}

      {showPrivacyPolicy ? <TermsAndPrivacy srcUrl={PRIVACY_POLICY} setIsOpen={setShowPrivacyPolicy} /> : null}
      {showTermsOfService ? <TermsAndPrivacy srcUrl={TERMS_OF_SERVICE} setIsOpen={setShowTermsOfService} /> : null}
    </nav>
  )
}

export default Nav
